exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host .jumbotron-container{margin-bottom:2rem;min-height:4rem;display:flex}:host .jumbotron-container .jumbotron-content{flex:1;padding:1rem 2rem;background:#f2eeeb}:host .jumbotron-container .jumbotron-content::ng-deep h1{margin:0;font-size:3.2rem;font-family:Perpetua;color:#2c2f33}:host .jumbotron-container .jumbotron-image{display:none;flex:1;background:url(" + require("../../../../content/images/navbar.png") + ") 0 no-repeat #f2eeeb;background-size:cover}@media screen and (min-width:768px){:host .jumbotron-container{min-height:6rem}:host .jumbotron-container .jumbotron-content{padding:3rem}:host .jumbotron-container .jumbotron-content::ng-deep h1{font-size:4rem;font-weight:400;line-height:4.5rem}:host .jumbotron-container .jumbotron-image{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/jumbotron/jumbotron.component.scss
// module id = 746
// module chunks = 0